"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetScoresResponseV2 = exports.GetScoreResponseDataV2 = exports.GetScoresQueryV2 = exports.GetScoreResponseV2 = exports.GetScoreQueryV2 = void 0;
const zod_1 = __importDefault(require("zod"));
const zod_2 = require("../../../../../utils/zod");
const shared_1 = require("../shared");
const schemas_1 = require("./schemas");
// GET /scores/{scoreId} v2
exports.GetScoreQueryV2 = shared_1.GetScoreQuery;
exports.GetScoreResponseV2 = schemas_1.APIScoreSchemaV2;
// GET /scores v2
exports.GetScoresQueryV2 = shared_1.GetScoresQuery.extend({
    sessionId: zod_1.default.string().nullish(),
    traceId: zod_1.default.string().nullish(),
    datasetRunId: zod_1.default.string().nullish(),
    observationId: zod_1.default
        .string()
        .transform((str) => str.split(",").map((id) => id.trim()))
        .refine((arr) => arr.every((id) => typeof id === "string"), {
        message: "Each observation ID must be a string",
    })
        .nullish(),
});
exports.GetScoreResponseDataV2 = zod_1.default
    .intersection(schemas_1.APIScoreSchemaV2, zod_1.default.object({
    trace: zod_1.default
        .object({
        userId: zod_1.default.string().nullish(),
        tags: zod_1.default.array(zod_1.default.string()).nullish(),
        environment: zod_1.default.string().nullish(),
        sessionId: zod_1.default.string().nullish(),
    })
        .nullish(),
}))
    .or(schemas_1.APIScoreSchemaV2);
exports.GetScoresResponseV2 = zod_1.default.object({
    data: zod_1.default.array(exports.GetScoreResponseDataV2),
    meta: zod_2.paginationMetaResponseZod,
});
